// extracted by mini-css-extract-plugin
module.exports = {"syncIcon":"CloudSync_syncIcon__1qkid","online":"CloudSync_online__3ewhh","updating":"CloudSync_updating__2fa5j","offline":"CloudSync_offline__1blbG"};